var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [_vm._m(0), _c("brands"), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4)],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "full__video" }, [
      _c(
        "div",
        {
          staticClass: "intro__content intro__content--mobile enterprise--intro"
        },
        [
          _c("h1", [_vm._v("Enterprise Plan")]),
          _c("h2", [
            _vm._v(
              "Modern marketers use cinemagraphs to create eye-catching content that drives real business results. Learn how Flixel works with enterprise clients."
            )
          ]),
          _c("div", { staticClass: "btn__group btn__group--splash" }, [
            _c("a", { attrs: { href: "mailto:support@flixel.com" } }, [
              _c("button", { staticClass: "btn btn--purpleLight" }, [
                _vm._v("Contact Us")
              ])
            ])
          ])
        ]
      ),
      _c("div", { staticClass: "fluid__video splash" }, [
        _c(
          "div",
          {
            staticClass:
              "intro__content intro__content--desktop enterprise--intro"
          },
          [
            _c("h1", [_vm._v("Enterprise Plan")]),
            _c("h2", [
              _vm._v(
                "Modern marketers use cinemagraphs to create eye-catching content that drives real business results. Learn how Flixel works with enterprise clients."
              )
            ]),
            _c("div", { staticClass: "btn__group btn__group--splash" }, [
              _c("a", { attrs: { href: "mailto:support@flixel.com" } }, [
                _c("button", { staticClass: "btn btn--purpleLight" }, [
                  _vm._v("Contact Us")
                ])
              ])
            ])
          ]
        ),
        _c("iframe", {
          attrs: {
            "data-src":
              "https://media.flixel.com/cinemagraph/zgznwtla5esqo0bqxtzd?hd=true",
            allow: "autoplay"
          }
        }),
        _c("div", { staticClass: "credit" }, [
          _c(
            "a",
            {
              attrs: { target: "_blank", href: "https://flixel.com/cinepix/" }
            },
            [_vm._v("Cinepix")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "enterprise__section" }, [
      _c("div", { staticClass: "enterprise--product" }, [
        _c("div", { staticClass: "title__container" }, [
          _c("h1", [_vm._v("What are Cinemagraphs?")]),
          _c("p", [
            _vm._v(
              "Cinemagraphs — sometimes known as living photos — blend photography and video together. They are composed like a photo that contain a perfectly looped motion. Cinemagraphs are shared as a short video file, and look great on social media, in e-mails, on digital displays, TV ads, and websites."
            )
          ])
        ])
      ]),
      _c(
        "div",
        {
          staticClass:
            "enterprise__section--container enterprise__container--row"
        },
        [
          _c("div", { staticClass: "enterprise__section--content" }, [
            _c("div", { staticClass: "enterpriseItem__title" }, [
              _c("img", {
                staticClass: "lazy",
                attrs: {
                  "data-srcset":
                    "https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon.png 1x"
                }
              }),
              _c("h2", [
                _vm._v("Cinemagraph Pro "),
                _c("br"),
                _c("span", [_vm._v("for macOS")])
              ])
            ]),
            _c("div", { staticClass: "productItem__desc" }, [
              _c("p", [
                _vm._v(
                  "Creating professional quality cinemagraphs is fast, fun, and easy with Cinemagraph Pro for macOS. Winner of a 2014 Apple Design Award and the world’s favorite way to create cinemagraphs."
                )
              ]),
              _c("div", { staticClass: "btn__group btn__group--splash" }, [
                _c("a", { attrs: { href: "mailto:support@flixel.com" } }, [
                  _c("button", { staticClass: "btn btn--purpleLight" }, [
                    _vm._v("Contact Us")
                  ])
                ])
              ])
            ]),
            _c("img", {
              attrs: {
                id: "designaward",
                srcset:
                  "https://cdn.flixel.com/static/static-web/awards/awardada@2x.png" +
                  " 2x, " +
                  "https://cdn.flixel.com/static/static-web/awards/awardada.png" +
                  " 1x"
              }
            })
          ]),
          _c("div", { staticClass: "enterprise__section--image" }, [
            _c("img", {
              staticClass: "lazy fcpImage",
              attrs: {
                "data-srcset":
                  "https://cdn.flixel.com/static/static-web/products/mac/cinemagraph-pro@2x.png 2x,https://cdn.flixel.com/static/static-web/products/mac/cinemagraph-pro.png 1x"
              }
            })
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "enterprise__section" }, [
      _c(
        "div",
        {
          staticClass:
            "enterprise__section--container product__section--reverse"
        },
        [
          _c("div", { staticClass: "enterprise__section--content" }, [
            _c("div", { staticClass: "enterprise--title" }, [
              _c("img", {
                staticClass: "lazy",
                attrs: {
                  "data-srcset":
                    "https://cdn.flixel.com/static/static-web/casestudies/pepsico@2x.png 2x, https://cdn.flixel.com/static/static-web/casestudies/pepsico@1x.png 1x"
                }
              }),
              _c("h2", [_vm._v("Cinemagraphs at work")])
            ]),
            _c("div", { staticClass: "enterpriseItem__desc" }, [
              _c("p", [
                _vm._v(
                  "PepsiCo is no stranger to generating brand awareness through visual storytelling. To launch their new lemon-lime beverage Mist Twst, they worked with Flixel Studios to test cinemagraph ads against still image ads on Facebook. The thumb-stopping engagement proved that cinemagraphs are the best way to put a twist on your campaign, and drive results."
                )
              ]),
              _c(
                "a",
                {
                  staticClass: "enterpriseItem__desc--purpleLink",
                  attrs: {
                    href:
                      "http://blog.flixel.com/pepsico-tests-cinemagraphs-in-facebook-ads/"
                  }
                },
                [_vm._v("Learn More >")]
              )
            ]),
            _c("div", { staticClass: "enterpriseItem__stats" }, [
              _c("div", { staticClass: "stat__item" }, [
                _c("div", { staticClass: "stat__item--number" }, [
                  _c("h2", [_vm._v("75%")])
                ]),
                _c("div", { staticClass: "stat__item--desc" }, [
                  _c("h3", [_vm._v("Increase in CTR")])
                ])
              ]),
              _c("div", { staticClass: "stat__item" }, [
                _c("div", { staticClass: "stat__item--number" }, [
                  _c("h2", [_vm._v("51x")])
                ]),
                _c("div", { staticClass: "stat__item--desc" }, [
                  _c("h3", [_vm._v("Increase in Engagement")])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "enterprise__section--cinemagraph" }, [
            _c("div", { staticClass: "fluid__video rounded__corners" }, [
              _c("iframe", {
                attrs: {
                  "data-src":
                    "https://media.flixel.com/cinemagraph/48dciji2l85olekpzckh?hd=true",
                  allow: "autoplay"
                }
              })
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "enterprise__section" }, [
      _c("div", { staticClass: "enterprise__section--container" }, [
        _c("div", { staticClass: "enterprise__section--header" }, [
          _c("h2", [_vm._v("Flixel Enterprise")]),
          _c("p", [
            _vm._v(
              "Custom cinemagraph software and services that help companies easily create dynamic video content, increase conversions, and stand out online."
            )
          ])
        ]),
        _c("div", { staticClass: "enterprise__section--grid" }, [
          _c("div", { staticClass: "enterprise__grid--item" }, [
            _c(
              "div",
              { staticClass: "enterprise__grid--img rounded__corners" },
              [
                _c("img", {
                  staticClass: "lazy",
                  attrs: {
                    "data-srcset":
                      "https://cdn.flixel.com/static/static-web/products/enterprise/cinemagraphprosquare@2x.png 2x, https://cdn.flixel.com/static/static-web/products/enterprise/cinemagraphprosquare.png 1x"
                  }
                })
              ]
            ),
            _c("div", { staticClass: "enterprise__grid--title" }, [
              _c("h3", [_vm._v("Cinemagraph Pro")])
            ]),
            _c("div", { staticClass: "enterprise__grid--desc" }, [
              _c("p", [
                _vm._v(
                  "Cinemagraph Pro for macOS licenses for each of your team members."
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "enterprise__grid--item" }, [
            _c("div", { staticClass: "enterprise__grid--img" }, [
              _c("div", { staticClass: "fluid__video rounded__corners" }, [
                _c("iframe", {
                  attrs: {
                    "data-src":
                      "https://media.flixel.com/cinemagraph/vs3y71og8bfgwgha9dav?hd=true",
                    allow: "autoplay"
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "enterprise__grid--title" }, [
              _c("h3", [_vm._v("Stills to Motion")])
            ]),
            _c("div", { staticClass: "enterprise__grid--desc" }, [
              _c("p", [
                _vm._v(
                  "Flixel Studios can turn your existing photo assets into mesmerizing cinemagraphs."
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "enterprise__grid--item" }, [
            _c("div", { staticClass: "enterprise__grid--img" }, [
              _c("div", { staticClass: "fluid__video rounded__corners" }, [
                _c("iframe", {
                  attrs: {
                    "data-src":
                      "https://media.flixel.com/cinemagraph/xwldyfcx0nhborb5jkth?hd=true",
                    allow: "autoplay"
                  }
                })
              ])
            ]),
            _c("div", { staticClass: "enterprise__grid--title" }, [
              _c("h3", [_vm._v("Consultation")])
            ]),
            _c("div", { staticClass: "enterprise__grid--desc" }, [
              _c("p", [
                _vm._v(
                  "Custom cinemagraph campaign consultation with Flixel Studios."
                )
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "enterprise__section--footer" }, [
          _c("h3", [_vm._v("+ Added Support")]),
          _c("p", [
            _vm._v(
              "24 hour reply and direct number call in during weekday hours (9am - 6pm EST)."
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "enterprise__section" }, [
      _c("div", { staticClass: "enterprise__section--callout" }, [
        _c("div", { staticClass: "callout__title" }, [
          _c("h1", [_vm._v("Tell your brand story with cinemagraphs")])
        ]),
        _c("div", { staticClass: "callout__text" }, [
          _c("p", [
            _vm._v(
              "Cinemagraphs resonate with audiences in ways that photos no longer can. Use cinemagraphs as a part of your digital marketing campaigns to drive higher CTRs, lower CPC, and increase engagement."
            )
          ])
        ]),
        _c("div", { staticClass: "btn__group" }, [
          _c(
            "a",
            {
              staticClass: "btn btn--purpleLight btn__splash",
              attrs: { href: "mailto:support@flixel.com" }
            },
            [_vm._v("Contact Us")]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b6718c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6718c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/products/enterprise.vue
// module id = null
// module chunks = 